// Route shapes shared by every product-listing surface: the marketplace, the logged-in vendor
// storefront, and the public storefront app (which has its own router).
//
// One factory keeps the three tables from drifting. Every route is named, because navigation
// goes through router.replace({ name, params, query }) and path assembly lives solely in
// services/marketplace/filterUrl.

/** Route names for a listing surface, matching what makeListingRoutes generates. */
export function listingRouteNames(namePrefix) {
  return {
    listing: `${namePrefix}Listing`,
    category: `${namePrefix}ListingCategory`,
    subcategory: `${namePrefix}ListingSubcategory`,
    product: `${namePrefix}Product`,
  };
}

/**
 * Build the ordered route block for one listing base.
 *
 * `basePath` is prefixed onto each path, so passing "" yields relative children for a nested
 * layout and passing "marketplace" yields a flat block. The product route is declared first to
 * make the static segment's precedence over `:category` obvious at a glance — vue-router ranks
 * static above param regardless of order.
 */
export function makeListingRoutes({ basePath = "", namePrefix, listing, product = null, productPath = "product/:productSlug", meta = {} }) {
  const names = listingRouteNames(namePrefix);
  const join = (suffix) => [basePath, suffix].filter(Boolean).join("/");
  const routes = [];

  if (product) {
    routes.push({ path: join(productPath), name: names.product, component: product, props: true, meta });
  }

  // Listing components read their filters from the route directly, so only the vendor slug is
  // forwarded as a prop — passing the category segments too would just land them on the DOM.
  const listingProps = (route) => ({ vendorSlug: route.params.vendorSlug });

  routes.push(
    { path: join(""), name: names.listing, component: listing, props: listingProps, meta },
    { path: join(":category"), name: names.category, component: listing, props: listingProps, meta },
    { path: join(":category/:subcategory"), name: names.subcategory, component: listing, props: listingProps, meta },
  );

  return routes;
}
